import { CryptoAssetType, type CryptoAsset } from '@/types/WalletTypes';

type CryptoAssetPredicate = (cryptoAsset: CryptoAsset) => boolean;

type CryptoAssetQuery = {
  assetType?: CryptoAssetType;
  chainId?: number | string | null;
  isDefaultLayer1?: boolean;
  isDefaultLayer2?: boolean;
  predicate?: CryptoAssetPredicate;
  symbol?: string;
};

export const isBitcoinCryptoAsset = (cryptoAsset?: CryptoAsset | null) => cryptoAsset?.traits.isBitcoin ?? false;

export const isEvmCryptoAsset = (cryptoAsset?: CryptoAsset | null) => cryptoAsset?.traits.isEvm ?? false;

export const isNativeCryptoAsset = (cryptoAsset?: CryptoAsset | null) => cryptoAsset?.traits.isNative ?? false;

export const isErc20CryptoAsset = (cryptoAsset?: CryptoAsset | null) => cryptoAsset?.traits.isErc20 ?? false;

const findCryptoAsset = (
  cryptoAssets: CryptoAsset[] = [],
  { assetType, chainId, isDefaultLayer1, isDefaultLayer2, predicate, symbol }: CryptoAssetQuery = {}
) =>
  cryptoAssets.find((asset) => {
    if (symbol && asset.asset.canonicalName !== symbol) return false;
    if (assetType !== undefined && asset.asset.assetType.id !== assetType) return false;
    if (
      chainId !== null &&
      chainId !== undefined &&
      Number(asset.asset.blockchainConfiguration.chainId) !== Number(chainId)
    ) {
      return false;
    }
    if (typeof isDefaultLayer1 === 'boolean' && asset.traits.isDefaultLayer1 !== isDefaultLayer1) {
      return false;
    }
    if (typeof isDefaultLayer2 === 'boolean' && asset.traits.isDefaultLayer2 !== isDefaultLayer2) {
      return false;
    }
    if (predicate && !predicate(asset)) return false;
    return true;
  });

export const findNativeCryptoAssetByChainId = (cryptoAssets: CryptoAsset[] = [], chainId?: number | string | null) =>
  findCryptoAsset(cryptoAssets, {
    assetType: CryptoAssetType.Native,
    chainId,
  });

export const findErc20CryptoAssetByChainIdAndSymbol = (
  cryptoAssets: CryptoAsset[] = [],
  chainId?: number | string | null,
  symbol?: string
) =>
  findCryptoAsset(cryptoAssets, {
    assetType: CryptoAssetType.Erc20,
    chainId,
    symbol,
  });

export const findDefaultLayer1NativeCryptoAsset = (cryptoAssets: CryptoAsset[] = []) =>
  findCryptoAsset(cryptoAssets, {
    assetType: CryptoAssetType.Native,
    isDefaultLayer1: true,
  });
